<template>
	<div>
		<el-dialog title="机构学生数据" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
			<span>
				<el-table height="calc( 100vh - 250px)" v-loading.fullscreen.lock="stu_loading"
					element-loading-text="数据加载中..." element-loading-spinner="el-icon-loading" :data="stu_lists"
					style="width: 95%;">
					<el-table-column type="expand">
						<template slot-scope="props ">
							<el-form label-position="left" inline class="demo-table-expand">
								<div class="form-row">
									<el-form-item label="学生姓名">
										<span>{{ props.row.stu_name }}</span>
									</el-form-item>
									<el-form-item label="年龄">
										<span>{{ props.row.age }}</span>
									</el-form-item>
								</div>

								<div class="form-row">
									<el-form-item label="类型">
										<span>{{ props.row.stu_disability }}</span>
									</el-form-item>
									<el-form-item label="一周总时长">
										<span>{{ props.row.z_time }}</span>
									</el-form-item>
								</div>

								<div class="form-row">
									<el-form-item label="个训的一周总时长">
										<span>{{ props.row.gx_time }}</span>
									</el-form-item>
									<el-form-item label="总时长是否合格">
										<span v-if="props.row.hg_zt_z == false" class="anniu">不合格</span>
										<span v-else class="unanniu">合格</span>
									</el-form-item>
								</div>

								<div class="form-row">
									<el-form-item label="个训时长是否合格">
										<span v-if="props.row.hg_zt_g == false" class="anniu">不合格</span>
										<span v-else class="unanniu">合格</span>
									</el-form-item>
									<el-form-item label="课时是否合格">
										<span v-if="props.row.hg_zt == false" class="anniu">不合格</span>
										<span v-else class="unanniu">合格</span>
									</el-form-item>
								</div>

								<div class="form-row">
									<el-form-item label="本月考勤数">
										<span>{{ props.row.sum }}</span>
									</el-form-item>
									<el-form-item label="档案完成度">
										<span>{{ props.row.percentage }}</span>
									</el-form-item>
								</div>
							</el-form>
						</template>
					</el-table-column>
					<el-table-column label="学生姓名" prop="stu_name">
						<template slot-scope="scope">
							<span @click="tiaozhuanda(scope.row)" class="name">{{ scope.row.stu_name }}</span>
						</template>
					</el-table-column>
					<el-table-column label="年龄" prop="age"></el-table-column>
					<el-table-column label="类型" prop="stu_disability"></el-table-column>
					<!-- <el-table-column label="课时合格" prop="stu_bhg"></el-table-column> -->
					<el-table-column label="档案完成度" prop="percentage"></el-table-column>
				</el-table>
			</span>
			<span style="display: flex;justify-content: center;align-items: center;">
				<el-button @click="xia">上一页</el-button>
				<span>第{{page}}/{{page_size}}页</span>
				<el-button @click="sha">下一页</el-button>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<div>
			<el-button type="danger" style="font-weight: 600;" size="mini">机构运行预警</el-button>
			<el-table height="calc( 96vh - 220px)" v-loading="org_loading" element-loading-text="数据加载中..."
				element-loading-spinner="el-icon-loading" :data="lists" style="width: 95%;margin-top: 20px;">
				<el-table-column label="机构名" prop="org_name"></el-table-column>
				<el-table-column label="学生数" prop="stu_sum"></el-table-column>
				<el-table-column label="当日考勤" prop="kqoqin_sum"></el-table-column>
				<el-table-column label="档案活跃" prop="dang_an"></el-table-column>
				<el-table-column label="课时合格" prop="name_bai"></el-table-column>
				<el-table-column label="课时不合格" prop="name_black"></el-table-column>
				<el-table-column fixed="right" label="查看操作" width="100">
					<template slot-scope="scope">
						<el-button @click="handleClick(scope.row)" type="primary" size="mini">查看</el-button>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="考勤表打印" width="100">
					<template slot-scope="scope">
						<el-button @click="dangan_copy(0,scope.row)" type=" danger"
							style="background-color: #d60000; color: white; font-weight: 550;"
							size="mini">考勤表打印</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex;align-items: center;margin-top: 1vh;">
				<div style="width: 10vw;">机构数量：{{sum}} 家</div>
				<el-pagination background layout="prev, pager, next" @current-change="a" :total="sum">
				</el-pagination>
				<el-switch style="margin-left: 20px;" @change="swith_up(1)" :disabled="org_loading"
					v-model="keshi_status" active-text="课时信息">
				</el-switch>
				<el-switch :disabled="org_loading" style="margin-left: 20px;" v-model="dangan_status"
					@change="swith_up(0)" active-text="档案信息">
				</el-switch>
				<el-switch style="margin-left: 20px;" @change="swith_up(1)" :disabled="org_loading"
					v-model="daka_status" active-text="当日考勤">
				</el-switch>
				<div class="block" style="font-size: 90%; margin-left: 20px; display: flex; align-items: center;">
					<span class="demonstration">日期选择:</span>
					<el-date-picker style="zoom:90%; margin-left: 1.6em;" v-model="date_time" type="datetime"
						placeholder="选择日期时间" align="right" :picker-options="pickerOptions">
					</el-date-picker>
				</div>
			</div>
		</div>
		<el-dialog :title="year+'年度机构考勤表打印'" :visible.sync="dialogFormVisible">
			<el-form :model="form">
				<el-form-item label="开始月份" :label-width="formLabelWidth">
					<el-select v-model="stat_yuefen" placeholder="请选择开始月份">
						<el-option label="一月" value="01"></el-option>
						<el-option label="二月" value="02"></el-option>
						<el-option label="三月" value="03"></el-option>
						<el-option label="四月" value="04"></el-option>
						<el-option label="五月" value="05"></el-option>
						<el-option label="六月" value="06"></el-option>
						<el-option label="七月" value="07"></el-option>
						<el-option label="八月" value="08"></el-option>
						<el-option label="九月" value="09"></el-option>
						<el-option label="十月" value="10"></el-option>
						<el-option label="十一月" value="11"></el-option>
						<el-option label="十二月" value="12"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="结束月份" :label-width="formLabelWidth">
					<el-select v-model="end_yuefen" placeholder="请选择结束月份">
						<el-option label="一月" value="01"></el-option>
						<el-option label="二月" value="02"></el-option>
						<el-option label="三月" value="03"></el-option>
						<el-option label="四月" value="04"></el-option>
						<el-option label="五月" value="05"></el-option>
						<el-option label="六月" value="06"></el-option>
						<el-option label="七月" value="07"></el-option>
						<el-option label="八月" value="08"></el-option>
						<el-option label="九月" value="09"></el-option>
						<el-option label="十月" value="10"></el-option>
						<el-option label="十一月" value="11"></el-option>
						<el-option label="十二月" value="12"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取 消</el-button>
				<el-button type="primary" @click="dangan_copy(1)">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				date_time: new Date(),
				pickerOptions: {
					shortcuts: [{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: '昨天',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: '一周前',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				dialogFormVisible: false,
				form: {},
				formLabelWidth: '120px',
				stat_yuefen: "",
				end_yuefen: "",
				page: 1,
				page_size: 0,
				page_z: 0,
				page_size_z: 10,
				org_id: '',
				org_loading: true,
				stu_loading: true,
				lists: [],
				stu_lists: [],
				keshi_status: false,
				daka_status: true,
				dangan_status: false,
				sum: 0,
				orgss: '',
				org_id_chu: '',
				dialogVisible: false
			}
		},
		props: {
			year: Number
		},
		computed: {
			info() {
				let info = window.localStorage.getItem("info");
				return JSON.parse(info);
			},
			org() {
				let org = window.localStorage.getItem("org");
				return JSON.parse(org);
			},
			teatoken(){
				return window.localStorage.getItem("tea_token");
			},
		},
		watch: {

		},
		methods: {
			tiaozhuanda(e) {
			if (e.stu_disability.includes("孤独症(精神)") || e.stu_disability.includes("智力")) {
				let routeData = this.$router.resolve({
					name: 'dangan',
					query: {
						stuid: e.stu_id,
						year: this.date_time
					}
				});
				window.open(routeData.href, '_blank')
			} else if (e.stu_disability.includes("肢体")) {
				let routeData = this.$router.resolve({
					name: 'dangan_zt',
					query: {
						stuid: e.stu_id,
						nian: this.date_time,
						org_id: this.org_id,
						stu_type: e.stu_disability,
						stu_name: e.stu_name
					}
				})
				window.open(routeData.href, '_blank');
			} else {
				let routeData = this.$router.resolve({
					name: 'dangan',
					query: {
						stuid: e.stu_id,
						year: this.date_time
					}
				});
				window.open(routeData.href, '_blank')
			}
		},
			swith_up(i) {
				this.org_loading = true
				this.lists = []
				this.getdata()
			},
			a(e) {
				this.keshi_status = false
				this.dangan_status = false
				this.daka_status = true
				this.org_loading = true
				this.page_z = (e - 1) * this.page_size_z
				this.lists = []
				this.getdata()
			},
			async sha() {
				this.stu_loading = true
				let a = 0
				this.page += 1
				if (this.page < this.page_size) {
					let a = this.page * 10
					let res = await axios.get(this.$urls + "teacher_y/get_org_stu_timeSx_qu_id_gai", {
						params: {
							qu_id: this.org.area,
							org_id: this.org_id,
							page: a,
							page_size: '10'
						},headers: {
							"token": this.teatoken
						}
					});
					this.stu_loading = false
					console.log(res.data[1].percentage, "6666666666");
					console.log(this.page, "this.page77777777777777777");
					this.stu_lists = res.data

				} else if (this.page = this.page_size) {
					this.stu_loading = false
				} else {
					this.stu_loading = false
				}
			},
			async xia() {
				let a = 0
				this.stu_loading = true
				if (this.page > 1) {
					this.page -= 1
					if (this.page == 1) {
						a = 0
					} else {
						a = this.page * 10
					}
					let res = await axios.get(this.$urls + "teacher_y/get_org_stu_timeSx_qu_id_gai", {
						params: {
							qu_id: this.org.area,
							org_id: this.org_id,
							page: a,
							page_size: '10'
						},headers: {
							"token": this.teatoken
						}
					});
					this.stu_loading = false
					console.log(res.data, "6666666666");
					console.log(this.page, "this.page222222222222");
					this.stu_lists = res.data
				} else {
					this.stu_loading = false
				}


			},
			handleClose(done) {
				done();
			},
			open() {
				this.$alert('这是一段内容', '标题名称', {
					confirmButtonText: '确定',
					callback: action => {}
				});
			},
			async dangan_copy(i, row) {
				if (i == 0) {
					this.dialogFormVisible = true
					this.org_id_chu = row
				} else {
					this.org_loading = true
					this.dialogFormVisible = false
					let res = await axios.get(this.$urls + "canlian/canlian_org_dangancopy", {
						params: {
							qu_id: this.org.area,
							stat_time: this.year + "-" + this.stat_yuefen + "-01",
							end_time: this.year + "-" + this.end_yuefen + "-31",
							org_name: this.org_id_chu.org_name,
							canlianb_name: this.org.name,
							peopre_name: this.info.name,
							org_id: this.org_id_chu.org_id
						},headers: {
							"token": this.teatoken
						}
					});
					this.org_loading = false
					if (res.data.status == 500 || res.data.status == 0) {
						this.$message.error(`${res.data.desc}`)
					} else {
						this.$confirm('Ctrl+S 保存', 'XSLX文件下载', {
							confirmButtonText: '跳转',
							cancelButtonText: '取消',
							type:"success"
						}).then(() => {
							this.$message({
								type: 'success',
								message: '跳转!'
							})
							window.open(this.$urls + res.data.path, '_blank')
						}).catch(() => {
							this.$message({
								type: 'info',
								message: '已取消'
							})
						})
					}
				}
		},
		async handleClick(row) {
			this.page = 1
			this.page_size = 0
			this.org_id = row.org_id
			for (let cc = 0; cc < this.lists.length; cc++) {
				if (this.lists[cc].org_id == row.org_id) {
					this.page_size = Math.ceil(this.lists[cc].stu_sum / 10)
				}
			}
			console.log(row.org_id, "dadsdads");
			let a = this.orgss
			if (a != row.org_id) {
				this.stu_lists = []
				this.orgss = row.org_id
				console.log(this.orgss, "this.orgss");
				this.dialogVisible = true
				this.stu_loading = true
				console.log(row.org_id);
				let res = await axios.get(this.$urls + "teacher_y/get_org_stu_timeSx_qu_id_gai", {
					params: {
						qu_id: this.org.area,
						org_id: row.org_id,
						page: this.page - 1,
						page_size: '10'
					},headers: {
						"token": this.teatoken
					}
				});
				this.stu_loading = false
				console.log(res.data[1], "6666666666");
				this.stu_lists = res.data
			} else {
				this.dialogVisible = true
			}
		},
		async getdata() {
			let res = await axios.get(this.$urls + "teacher_y/get_stu_timeSx_qu_id_gai", {
				params: {
					qu_id: this.org.area,
					page: this.page_z,
					page_size: this.page_size_z,
					keshi_status: !this.keshi_status,
					kaoqin_loading: !this.daka_status,
					dangan_status: !this.dangan_status,
					date_time: this.date_time,
					year:this.year
				},headers: {
					"token": this.teatoken
				}
			});
			this.lists = res.data.org_stu_list;
			this.sum = res.data.sum;
			this.org_loading = false
		}
	},
	created() {
		this.getdata();
	}
	}
</script>
<style>
.name {
	text-decoration: none;
	color: black;
}

.name:hover {
	text-decoration: underline;
	color: blue;
}


	.form-row {
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.anniu {
		color: red;
	}

	.unanniu {
		color: #409EFF;
	}

	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 90px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>